'use client';

import { useIsTablet } from '@/app/_hooks/useIsScreen';
import { CLIENT_ENV } from '@/config/configuration';
import { Patient } from '@/types/patient';
import { trackClickHeaderAccediRegistrati } from '@/utils/trackingGtm';
import { AvatarUser } from '@davincihealthcare/elty-design-system-react';

type Props = {
  patient: Patient;
  size?: 'small' | 'medium';
};

export const PatientInfoButton = ({ patient, size = 'small' }: Props) => {
  const isTabletAndSmaller = useIsTablet();

  const { NEXT_PUBLIC_WEBAPP_PATIENT_URL } = CLIENT_ENV();

  const onButtonClick = () => {
    trackClickHeaderAccediRegistrati();
    window.location.href = NEXT_PUBLIC_WEBAPP_PATIENT_URL;
  };

  return (
    <button
      type="button"
      className="flex items-center gap-2 text-neutral-darker"
      onClick={onButtonClick}
      aria-label={`${patient.name} ${patient.surname}`}
    >
      <AvatarUser alt="Avatar" src={''} size={size} name={patient.name} surname={patient.surname} />
      {!isTabletAndSmaller && <p>{`${patient.name} ${patient.surname}`}</p>}
    </button>
  );
};
